import { KdsText, KdsTextField } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { Controller, useFormContext } from "react-hook-form";

import { CollapseSection } from "@/components/CollapseSection/CollapseSection";

import { type OrderItemConfigurationSchema } from "../OrderItemConfigForm.schema";
import { type ReferenceIdSectionProps } from "./ReferenceIdSection.types";

export const ReferenceIdSection = ({
  isOpen,
  onOpenChange,
}: ReferenceIdSectionProps) => {
  const { t } = useTranslate();

  const methods = useFormContext<OrderItemConfigurationSchema>();

  return (
    <CollapseSection
      size="medium"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      variant="transparent"
      title={t("orderItemConfig.section.referenceIdTitle")}
    >
      <div className="flex flex-col gap-sp-xs">
        <KdsText color="text-bodyvariant">
          {t("orderItemConfig.section.referenceIdDescription")}
        </KdsText>

        <Controller
          {...methods}
          name="clientReference"
          render={({ field }) => (
            <KdsTextField
              placeholder={t("orderItemConfig.section.referenceIdPlaceholder")}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </div>
    </CollapseSection>
  );
};
